import { useSelector } from "react-redux";
import { useEffect } from "react";
import { RootState } from "web/redux/store";
import { BannerSize } from "web/script/utils/app-banner-campaign";
import environment from "web/script/modules/environment";

// This hooks is going to add a `className` to a specific DOM Element (`getNode`),
// in the case the below Top Banner conditions are met.
export function useTopBannerClass(getNode: () => Element, className: string): void {
    const topBanner = useSelector((state: RootState) => state.topBannerReducer);
    const topBannerIsInView = useSelector(
        (state: RootState) => state.followDesignerBannerReducer.show
    );

    let hasTopPadding = topBanner.isVisible;

    if (environment.getFeature("mg_enable_top_and_du_banners")) {
        hasTopPadding = topBanner.isVisible && !topBannerIsInView;
    }

    useEffect(() => {
        const node = getNode();
        const isVisible =
            hasTopPadding &&
            (topBanner.bannerSize === BannerSize.Small || topBanner.bannerType === "email_banner");

        if (isVisible) {
            node.classList.add(className);
        } else {
            node.classList.remove(className);
        }
    }, [topBanner, getNode, className, topBannerIsInView]);
}
